var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white absolute-100-percent"},[_c('empty-notice',{attrs:{"image":'search',"desc":'页面不存在'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }